import './Checkbox.css';

export function Checkbox(props: Readonly<{ checked: any; onChange?: (checked: boolean) => void; disabled?: boolean; text?: string, children?: any }>) {
   const { text, checked, onChange, disabled, children } = props;

   return (
      <div
         className="flex items-end gap-1 pointer"
         onClick={() => onChange && onChange(!checked)}>
         <div className={`checkbox ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}>
            {checked && (
               <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
               </svg>
            )}
         </div>
         {text && <span className="grey small">{text}</span>}
         {children }
      </div>
   );
}
